// CompanySelect.jsx
import React, { useEffect, useState } from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

const UserTypeSelect = ({ value, onChange = null, label = "User Type", ...props }) => {

  const [selectedValue, setSelectedValue] = useState(value);
  const handleSelect = (e) => {
    setSelectedValue(e.target.value);
    onChange(e.target.value);
  };

  const [types, setType] = useState([
    {id: 0, value: 'administrator', label: 'Administrator (full access)'},
    {id: 1, value: 'standard', label: 'Standard (configurable access)'}
  ]);


  return (
    <FormControl fullWidth {...props}>
      <InputLabel>{label}</InputLabel>
        <Select value={selectedValue} onChange={handleSelect} label={label} >
          {types.map((type) => (
            <MenuItem 
              key={type.id} 
              value={type.value}
            >
              {type.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
  );
};

export default UserTypeSelect;